import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import UserCredits from './UserTabs/UserCredits';
import ScheduleAdmin from '../Timesheet/ScheduleAdmin';
import UserLoans from './UserTabs/UserLoans';
import Dialog from '../../common/Dialog';
import UserInfo from './UserTabs/UserInfo';

class UserSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        total: 0,
    }
   
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

  

    render() {
        const { user } = this.props;
        return (
            // <Dialog
            //     // disableBackdropClick
            //     open={true}
            //     // onClose={this.props.handleClose}
            //     onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleCloseAll()} }
            //     aria-labelledby="form-dialog-title"
            //     maxWidth="lg"
            //     fullScreen
            //     scroll="paper"
            // >
               
            //     <AppBar style={{position: 'relative'}} color="secondary">
            //         <Toolbar>
            //             <IconButton color="inherit" onClick={this.props.handleCloseAll} aria-label="Close">
            //                 <Close />
            //             </IconButton>
            //             <Typography variant="h6" color="inherit">
            //             {user.username} {user.lastname.toUpperCase()}
            //             </Typography>
            //         </Toolbar>
            //     </AppBar>
                    
            //     <DialogContent>
            <Dialog
                appBar
                close={this.props.handleCloseAll}
                title={`${user.username} ${user.lastname.toUpperCase()}`}
                fullScreen
            >
                <Box>
                    {this.props.IMMO ?
                        <Box p={3}>
                            <UserLoans
                                {...this.props}
                                userID={this.props.user.user_id}
                            />
                        </Box>
                    :
                        <SwipeableTabs
                            labels={this.props.labels || ["Info", "Balance", "Planning", "Materiel"]}
                        >
                            <Box p={3}>
                                <UserInfo
                                    {...this.props}
                                />
                            </Box>
                            <Box p={3}>
                                <UserCredits 
                                    {...this.props}
                                />
                            </Box>
                            <Box p={3}>
                                <ScheduleAdmin
                                    {...this.props}
                                    employeeID={this.props.user.user_employee_id}
                                    openFormDownload={this.props.openFormDownloadTimesheet}
                                />
                            </Box>
                            <Box p={3}>
                                <UserLoans
                                    {...this.props}
                                    userID={this.props.user.user_id}
                                />
                            </Box>
                        </SwipeableTabs>
                    }
                </Box>
            </Dialog>
            //     </DialogContent>
            // </Dialog>
        );
    }
}

export default UserSingle;